module.exports = __webpack_public_path__ + "static/media/COMPUTADOR.1f2d11a5.png";